import { IRootState } from 'reducers';
import { createSelector } from 'reselect';
import { extractDatesFromNestedItems } from 'utils';

export const independentDiagnosticsYearsSelector = createSelector(
  (state: IRootState) => state.independentDiagnostics.content,
  (independentDiagnostics) =>
    extractDatesFromNestedItems(independentDiagnostics, [
      {
        type: 'academicYearString',
        field: 'learningYear',
      },
    ]),
);
